module.exports = "/wwwroot/img/related_pages_block.png?ver=87faf117";